@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.auto-split-settings-container {
  font-size: 14px;
  font-weight: 400;
  color: @auto-split-option--label--font-color;
}

.auto-split-settings-sub-text {
  font-size: 12px;
  font-weight: 400;
  color: @auto-split-option--sub-text--font-color;
  padding-left: @space-24;
  padding-top: @space-4;
}

.auto-split-settings-option {
  padding: @space-8 @space-0;
}

.auto-split-settings-radio-button {
  padding: @space-0;
}

.ship-by-quantity-input {
  width: 100px;
  margin-left: @space-24;
  margin-top: @space-4;
}

.auto-split-error {
  color: @auto-split-option--error--text-color;
  padding-left: @space-24;
}
